import * as React from "react";
import { IOrder } from "./fetchOrder";

export const OrderContext = React.createContext<IOrder | undefined>(undefined);

export function useOrder() {
  const value = React.useContext(OrderContext);

  if (value === null) {
    throw new Error("`Missing OrderContext` in tree.");
  }

  return value;
}
